// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1wRNb","buttons":"RemoveExpirationActionButtons_buttons__1tuFd"};